import * as React from 'react'
import { Tag } from 'antd'

interface Props {
  className?: string
  invoicePaid: number
  invoiceTotal: number
}

export const PaymentStatus = (props: Props) => {
  const { className, invoicePaid, invoiceTotal } = props

  let badgeColor: string | undefined
  let badgeContent: string | undefined

  switch (true) {
    case invoicePaid === 0:
      badgeColor = 'red'
      badgeContent = 'Unpaid'
      break
    case invoicePaid === invoiceTotal:
      badgeColor = 'green'
      badgeContent = 'Paid'
      break
    default:
      badgeColor = 'orange'
      badgeContent = 'Partial'
  }

  return (
    <Tag color={badgeColor} className={className}>
      {badgeContent}
    </Tag>
  )
}
